module.exports = __webpack_public_path__ + "static/Bitmap_1.b25fe1d7.png";